<div class="ticket-info-card">
  <span class="label">
    <ng-content select="[label]"></ng-content>
  </span>

  <span class="value">
    <ng-content select="[value]"></ng-content>
  </span>
</div>
